import script from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"

import "./SvgIcon.vue?vue&type=style&index=0&id=4fbc2598&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fbc2598"]])

export default __exports__